var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "mb-2 font-weight-bold" }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
      _vm.isPercentage()
        ? _c("span", { staticClass: "float-right" }, [
            _vm._v(_vm._s(_vm.numerator) + "%")
          ])
        : _vm.isDisabled
        ? _c("span", { staticClass: "float-right" }, [
            _vm._v(_vm._s(_vm.numerator) + "u")
          ])
        : _c("span", { staticClass: "float-right" }, [
            _vm._v(_vm._s(_vm.numerator) + "/" + _vm._s(_vm.denominator) + "u")
          ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "progress progress-sm" }, [
      !_vm.isDisabled
        ? _c("div", {
            staticClass: "progress-bar",
            style: "width: " + _vm.calculatedPercentage + "%;",
            attrs: {
              role: "progressbar",
              "aria-valuenow": _vm.numerator,
              "aria-valuemin": "0",
              "aria-valuemax": _vm.denominator
            }
          })
        : _c("div", {
            staticClass: "progress-bar-striped bg-secondary",
            style: "width:100%;",
            attrs: {
              role: "progressbar",
              "aria-valuenow": _vm.numerator,
              "aria-valuemin": "0",
              "aria-valuemax": _vm.denominator
            }
          })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }